type ManagePlanUsageBarProps = {
  used: number;
  total: number;
  colorClassName: string;
};

export function ManagePlanUsageBar({
  used,
  total,
  colorClassName,
}: ManagePlanUsageBarProps) {
  const percentage = total > 0 ? Math.min((used / total) * 100, 100) : 0;

  return (
    <div className="space-y-2.5">
      <div className="flex items-center gap-3">
        <div className="text-sm text-gray-500">Current usage</div>
        <div className="h-px flex-1 border-b border-dashed border-gray-200" />
        <div className="whitespace-nowrap text-[13px] font-medium text-gray-700">
          {used} / {total}
        </div>
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-gray-100">
        <div
          className={`h-1.5 rounded-full transition-all ${colorClassName}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
